export const MAP_STYLE = {
  street: "mapbox://styles/mapbox/standard",
};

export const LAYERS = {
  broker: "broker",
  property: "property",
  motor: "motor",
};

export const MARKER_COLORS = {
  broker: "#1565C0",
  property: "#9575CD",
  motor: "#4A148C",
};

export const CLAIM_MARKER_COLOR = "#C62828";

export const CHART_COLORS = {
  property: "#9575CD",
  motor: "#4A148C",
};

export const INITIAL_VIEW = {
  longitude: 23.7348,
  latitude: 37.9755,
  zoom: 10.5,
};

export const SIDEBAR_MIN_WIDTH = 460;
export const SIDEBAR_STORAGE_KEY = "portfolio-explorer-sidebar-width";

export const EMPTY_FILTERS = {
  postalCodes: [],
  cities: [],
  regions: [],
  countries: [],
};

export const SOURCE_ID = "portfolio-explorer-entities";
export const CLUSTER_LAYER_ID = "portfolio-explorer-clusters";
export const CLUSTER_COUNT_LAYER_ID = "portfolio-explorer-cluster-count";
export const POINT_LAYER_ID = "portfolio-explorer-points";
export const ICON_LAYER_ID = "portfolio-explorer-icons";
export const LABEL_LAYER_ID = "portfolio-explorer-labels";
export const ACCIDENT_SOURCE_ID = "portfolio-explorer-accidents";
export const ACCIDENT_POINT_LAYER_ID = "portfolio-explorer-accident-points";
export const ACCIDENT_ICON_LAYER_ID = "portfolio-explorer-accident-icons";
export const ACCIDENT_LABEL_LAYER_ID = "portfolio-explorer-accident-labels";
